import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

const GetMyAccountCustomFields = graphql(`
  query GetMyAccountCustomFields {
    me {
      user {
        account {
          customFields {
            value
            field {
              identifier
              isRequired
              label
              type
              options
              schema
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountCustomFields = (enabled = true) => {
  const { data, ...rest } = useQuery({
    enabled,
    queryKey: meKeys.accountCustomFields(),
    queryFn: () => gqlClient.request(GetMyAccountCustomFields),
  });

  return { customFields: data?.me.user.account.customFields, data, ...rest };
};

export default useGetMyAccountCustomFields;
